module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/en/4/5-eeb0af73eb5b8e5ddcd94ddecff2d213.jpg";